// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2dHPU","colCheckbox":"styles_colCheckbox__2sLw9"};